<script lang="ts">
import { defineComponent, h, resolveComponent, type VNode } from 'vue';

import CommonChip from '@/bundles/Common/components/chips/CommonChip.vue';

export default defineComponent({
  name: 'ConfidentialChip',

  render (): VNode {
    const VIcon = resolveComponent('v-icon');

    return h(CommonChip, {
      ...this.$attrs,
      color: 'orange-darken-3',
      class: 'text-white',
    }, { default: () => [
      h(VIcon, {
        class: 'mr-1',
        size: 'small',
      }, { default: () => 'mdi-shield-lock-outline' }),
      'Confidential',
    ] });
  }
});
</script>
